import { render, staticRenderFns } from "./ProductClassModal.vue?vue&type=template&id=ba246bf0&scoped=true&"
import script from "./ProductClassModal.vue?vue&type=script&lang=js&"
export * from "./ProductClassModal.vue?vue&type=script&lang=js&"
import style0 from "./ProductClassModal.vue?vue&type=style&index=0&id=ba246bf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba246bf0",
  null
  
)

export default component.exports